import React from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import bindAll from 'lodash.bindall';
import LibraryComponent from '../../../components/library/library-no-modal';

class CourseList extends React.PureComponent {
    constructor(props) {
        super(props);
        bindAll(this, [
            'handleItemSelect'
        ]);
    }

    handleItemSelect(item) {
        this.props.history.push("/course?id=" + item.extensionId);
    }
    render() {
        const items = this.props.items.map(item=>({
            extensionId: ''+item.id,
            name: item.name,
            rawURL: window.config.staticURL + '/cover/course/' + item.id + '.png',
            //iconRawURL: "/static/appstore.png",
            insetIconURL: item.studying ? require('./studying.png') : undefined,
            featured: true,
            //disabled: false,
            //cornerText: window.L('teach.course.locked'),
            //description: item.desc,

        }));
        return (
            <React.Fragment>
                {/*<img style={{position: "absolute", zIndex:1, left:"18px", top:"21px"}} src={require('./new.png')} />*/}
                <LibraryComponent
                    data={items}
                    filterable={!!this.props.filterable}
                    id="CourseLibrary"
                    title="课程列表"
                    visible={true}
                    onItemSelected={this.handleItemSelect}
                    onRequestClose={this.props.onRequestClose}
                />
            </React.Fragment>
        );
    }
}

CourseList.propTypes = {
    items: PropTypes.arrayOf(PropTypes.object),
    onRequestClose: PropTypes.func
}

export default withRouter(CourseList);
